// extracted by mini-css-extract-plugin
export default {"card":"Card_card__AdPHq","number":"Card_number__FLhwA","right":"Card_right__pLr6k","title":"Card_title__qxUup","description":"Card_description__WZUln"};